import { createElement, memo, useEffect, useMemo, useState, useRef, useContext } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import Button from '@hfe/max-button';
import ScrollView from '@hfe/max-scrollview';
import LinearGradient from '@hfe/max-linear-gradient';
import { rpx2px } from '@hfe/max-universal-unit-tool';
import TopView from '@max/leez-top-view';
const isMRN = false;
import './index.scss';
// import { BID } from '../../common/lx';
import { getSafeAreaMarginBottom } from "@max/meituan-uni-screenInfo";
import { CouponStatus, BizLine } from '../../constants';
import { useThrottle } from '../../hooks/useThrottle';
import { isMeituanAppOrWebview } from '@nibfe/mkt-env-api';
import { navigateTo } from '@max/meituan-uni-navigate';
import { getHistoryPrize } from '../../api/request';
import LoadingView from '@max/leez-loading-view';
import BottomSliderModal from '../bottom-slider-modal';
import CloseBtn from '../close-btn';
const LEVEL_UI_DEFAULT = {
    backgroundImageUrl: 'https://p0.meituan.net/ingee/f668adbf537a9871c190d50f28e9902110197.png',
    headImgUrl: 'https://p0.meituan.net/ingee/8f1bbd5f93cd25dadf93a2c627a9da1b189201.png',
    tabTextColor: '#555555',
    tabTextActiveColor: '#111111',
    tabIndecatorColors: ['#FFD65B', '#FFD65B'],
    couponBgColor: '#ffffff',
    priceSymbolTextColor: '#FF2D19',
    priceValueTextColor: '#FF2D19',
    limitDescTextColor: '#FF2D19',
    commonTextColor: '#555555',
    prizeNameColor: '#111111',
    emptyImgUrl: 'https://p0.meituan.net/ingee/f492314a58e6fe5554507859f41470d250411.png',
    emptyTextColor: '#241103B3'
};
const PRIZE_TAB = [{
        label: '境内酒店',
        key: 'hotel',
        values: [BizLine.hotel
            // BizLine.homeStay
        ]
    }, {
        label: '火车票',
        key: 'train',
        values: [BizLine.train]
    }, {
        label: '机票',
        key: 'air',
        values: [BizLine.air]
    }, {
        label: '景点',
        key: 'ticket',
        values: [BizLine.ticket]
    }, {
        label: '度假',
        key: 'vacation',
        values: [BizLine.vacation]
    }];
const TAB_LIST = [{
        label: '全部',
        key: 'all',
        values: []
    }, ...PRIZE_TAB];
const getBtnText = (status) => {
    switch (status) {
        case CouponStatus.ToUse:
            return '去使用';
        case CouponStatus.Used:
            return '已使用';
        case CouponStatus.Expired:
            return '已过期';
        case CouponStatus.Already:
            return '去使用';
        case CouponStatus.Claimed:
            return '去使用';
        default:
            return '';
    }
};
const getDesc = (couponData) => {
    if (couponData.prizeDesc)
        return couponData.prizeDesc;
    if (couponData.amountType === 2) {
        return `最高减${Math.floor(Number(couponData.maxDiscountAmount) / 100)}`;
    }
    return couponData.requireAmount || '无门槛';
};
const processAmount = (couponData) => {
    if (couponData.amountType === 1) {
        return Math.floor(Number(couponData.amount) / 100);
    }
    else {
        return Number(couponData.amount) / 10;
    }
};
let safeBottomHeight = getSafeAreaMarginBottom() ?? 0; //获取底部安全高度
safeBottomHeight = Math.max(safeBottomHeight, 20);
const CouponUsageRecord = (props) => {
    const ctx = useContext(global._EngineGlobalContext);
    const { modalVisible, activityIdList, onCloseModal, jumpConfig, toastConfig, commonParams, marketingId = 1, cityId = 1 } = props;
    const [activeIndex, setActiveIndex] = useState(0);
    const [allCouponData, setAllCouponData] = useState({}); // 存储所有tab的数据
    const [showLoading, setShowLoading] = useState(false);
    const [countdownTick, setCountdownTick] = useState(0); // 用于触发倒计时更新
    const scrollViewRef = useRef(null);
    const styleConfig = LEVEL_UI_DEFAULT;
    // 计算当前显示的优惠券列表
    const displayedCouponList = useMemo(() => {
        const currentTab = TAB_LIST[activeIndex];
        const key = currentTab.key;
        const data = allCouponData[key] || [];
        return data;
    }, [allCouponData, activeIndex]);
    // 管理多个到期时间文本，key 为优惠券的唯一标识（uuidAndIdx）
    const expireTimeMap = useMemo(() => {
        const map = {};
        displayedCouponList.forEach((couponItem) => {
            if (!couponItem.expireTime || couponItem.expireTime <= 0) {
                if (couponItem.prizeStatus === CouponStatus.Used) {
                    map[couponItem.uuidAndIdx] = '优惠券已使用';
                }
                else if (couponItem.prizeStatus === CouponStatus.Expired) {
                    map[couponItem.uuidAndIdx] = '优惠券已过期';
                }
                else {
                    map[couponItem.uuidAndIdx] = '';
                }
            }
            else {
                const now = Date.now();
                const diffMs = couponItem.expireTime - now;
                if (diffMs <= 0) {
                    if (couponItem.prizeStatus === CouponStatus.Used) {
                        map[couponItem.uuidAndIdx] = '优惠券已使用';
                    }
                    else if (couponItem.prizeStatus === CouponStatus.Expired) {
                        map[couponItem.uuidAndIdx] = '优惠券已过期';
                    }
                    else {
                        map[couponItem.uuidAndIdx] = '';
                    }
                }
                else {
                    const diffDays = Math.floor(diffMs / (24 * 60 * 60 * 1000));
                    if (diffDays > 6) {
                        const expireDate = new Date(couponItem.expireTime);
                        const month = String(expireDate.getMonth() + 1).padStart(2, '0');
                        const date = String(expireDate.getDate()).padStart(2, '0');
                        map[couponItem.uuidAndIdx] = `${month}/${date}到期`;
                    }
                    else if (diffDays > 0) {
                        map[couponItem.uuidAndIdx] = `${diffDays}天后到期`;
                    }
                    else {
                        const diffSeconds = Math.floor(diffMs / 1000);
                        const hours = Math.floor(diffSeconds / 3600);
                        const minutes = Math.floor(diffSeconds % 3600 / 60);
                        const seconds = diffSeconds % 60;
                        const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
                        map[couponItem.uuidAndIdx] = `${formattedTime} 后到期`;
                    }
                }
            }
        });
        return map;
    }, [displayedCouponList, countdownTick]);
    // 每秒更新倒计时
    useEffect(() => {
        const timer = setInterval(() => {
            setCountdownTick(prev => prev + 1);
        }, 1000);
        return () => clearInterval(timer);
    }, []);
    const fetchCouponUsageList = async (params) => {
        // console.log('params-------------', params);
        let data = [];
        try {
            const res = await getHistoryPrize(params, commonParams);
            // console.log('res-------------', res);
            data = res?.prizeList?.map((item, idx) => ({
                ...item,
                uuidAndIdx: item.uuid + String(idx)
            })) || [];
            // data = res.prizeList.map((item: UserPrizeInfo) => ({ ...item }))
            // console.log('data-----', data)
        }
        catch (error) {
            ctx._uiInteractionAPI.toast.show({
                content: '网络开小差了，请稍后重试~'
            });
            data = [];
        }
        return data;
    };
    const categorizeDataByTab = (data) => {
        const categorizedData = {};
        // 初始化所有tab的数据为空数组
        TAB_LIST.forEach(tab => {
            const tabKey = tab.key;
            categorizedData[tabKey] = [];
        });
        // console.log('categorizedData-----data', data)
        // 将数据按照类型分类到对应的tab中
        data.forEach(item => {
            categorizedData.all.push(item);
            const { bizLine } = item;
            const targetTab = PRIZE_TAB.find(tab => tab.values.includes(bizLine));
            if (targetTab) {
                categorizedData[targetTab.key].push(item);
            }
        });
        return categorizedData;
    };
    useEffect(() => {
        if (modalVisible) {
            loadData();
        }
    }, [modalVisible]);
    useEffect(() => { }, [activeIndex]);
    // 加载数据
    const loadData = async () => {
        const params = {
            activityIdList: activityIdList.filter(item => item),
            marketingId,
            cityId
        };
        setShowLoading(true);
        const data = await fetchCouponUsageList(params);
        // console.log('data-----', data)
        const usagedDatas = data; //.filter(item => item.prizeStatus === CouponStatus.used);
        // console.log('usagedDatas-----', usagedDatas)
        const categorizedData = categorizeDataByTab(usagedDatas);
        // console.log('categorizedData-----', categorizedData)
        setAllCouponData(categorizedData);
        setShowLoading(false);
    };
    const handleCouponClick = useThrottle(async (couponData) => {
        if (couponData.prizeStatus !== CouponStatus.NotClaimed) {
            const urlObj = new URL(couponData.jumpUrl || jumpConfig[couponData.bizLine]);
            const MTH5Url = 'https://w.dianping.com/cube/evoke/meituan.html?url=';
            const evokeMtAappUrl = isMeituanAppOrWebview() || isMRN ? urlObj.toString() : `${MTH5Url}${encodeURIComponent(urlObj.toString())}`;
            navigateTo({
                url: evokeMtAappUrl.replace(/\/$/, '') || '',
                _web: {
                    miniProgramNative: true
                }
            });
            return;
        }
    }, 300, () => {
        ctx._uiInteractionAPI.toast.show({
            content: toastConfig.tooFastTip
        });
    });
    const renderContent = () => <View className="coupon-usage-record__container">
      {/* Tabs */}
      <View className="tab-container">
        {TAB_LIST.map((item, index) => {
            const tabCouponCount = allCouponData[item.key]?.length || 0;
            return <Button key={item.key} className='tab-item' onPress={() => {
                    setActiveIndex(index);
                }}>
                <Text className="tab-text" style={{
                    color: activeIndex === index ? styleConfig.tabTextActiveColor : styleConfig.tabTextColor,
                    fontSize: activeIndex === index ? '28rpx' : '26rpx'
                }}>{item.label}<Text x-if={item.key === 'all'} className="tab-text-append">{tabCouponCount}</Text></Text>

                <LinearGradient className="tab-line" colors={styleConfig.tabIndecatorColors} style={{
                    opacity: activeIndex === index ? 1 : 0
                }} start={{
                    x: 0,
                    y: 0
                }} end={{
                    x: 1,
                    y: 1
                }}/>
              </Button>;
        })}
      </View>
      <ScrollView className="coupon-usage-record__scroll-view" showsVerticalScrollIndicator={false} ref={scrollViewRef}>
        <View x-if={displayedCouponList?.length >= 1} className="coupon-usage-record__content" style={{
            paddingBottom: safeBottomHeight
        }}>
          {displayedCouponList?.map((couponItem, index) => {
            const btnText = getBtnText(couponItem.prizeStatus);
            const btnTextColor = btnText === '去使用' ? {
                color: '#FF4B10'
            } : btnText === '已使用' ? {
                color: '#888888'
            } : {
                color: '#C2C2C2'
            };
            const otherTextColor = btnText === '已过期' ? {
                color: '#C2C2C2'
            } : {};
            return <View className="coupon-usage-item-wrap" style={{
                    backgroundColor: styleConfig.couponBgColor
                }} onClick={() => handleCouponClick(couponItem)}>
                <View className="coupon-usage-item-left">
                  <View className="coupon-usage-item-price">
                    <Text x-if={couponItem.amountType === 1} className="coupon-usage-item-price-symbol" style={{
                    color: styleConfig.priceSymbolTextColor,
                    ...otherTextColor
                }}>¥</Text>
                    <Text className="coupon-usage-item-price-value" style={{
                    color: styleConfig.priceValueTextColor,
                    ...otherTextColor
                }}>{processAmount(couponItem)}</Text>
                    <Text x-if={couponItem.amountType === 2} className="coupon-usage-item-price-symbol2" style={{
                    color: styleConfig.priceSymbolTextColor,
                    ...otherTextColor
                }}>折</Text>
                  </View>
                  <Text className="coupon-usage-item-condition" numberOfLines={1} style={{
                    color: styleConfig.limitDescTextColor,
                    ...otherTextColor
                }}>{getDesc(couponItem)}</Text>
                </View>
                <View className="coupon-usage-item-mid">
                  <Text className="coupon-usage-item-title" numberOfLines={1} style={{
                    color: styleConfig.prizeNameColor,
                    ...otherTextColor
                }}>{couponItem.prizeName}</Text>
                  <Text className="coupon-usage-item-period" numberOfLines={1} style={{
                    color: styleConfig.commonTextColor,
                    ...otherTextColor
                }}>{expireTimeMap[couponItem.uuidAndIdx] || ''}</Text>
                  {/* <Text className="coupon-usage-item-limit" numberOfLines={1} style={{color: styleConfig.commonTextColor}}>{couponItem.prizeDesc}</Text> */}
                </View>
                <View className="coupon-usage-item-right">
                  {/*  */}
                  <Text className="coupon-usage-item-status" style={{
                    ...btnTextColor,
                    borderColor: btnText === '去使用' ? '#FF4B10' : 'transparent'
                }}>{getBtnText(couponItem.prizeStatus)}</Text>
                </View>
              </View>;
        })}
          <LoadingView x-if={showLoading} level={'medium'} showContent={false} style={{
            marginTop: '10rpx'
        }}/>
        </View>

        <View x-if={!showLoading && (!Array.isArray(displayedCouponList) || displayedCouponList?.length < 1)} className="coupon-usage-record__empty-content">
          <LImage source={{
            uri: styleConfig.emptyImgUrl
        }} width={rpx2px(300)} height={rpx2px(326)}/>
          <Text className="coupon-usage-record__empty-text" style={{
            color: styleConfig.emptyTextColor || styleConfig.commonTextColor
        }}>暂无领券记录</Text>
        </View>

      </ScrollView>
    </View>;
    return <TopView>
      <BottomSliderModal heightInRpx={'1095rpx'} visible={modalVisible} onClose={onCloseModal} topBanner={<View className="coupon-list-title">
            {/* <LImage
              source={{ uri: styleConfig.headImgUrl }}
              style={{ borderRadius: 0, overflow: 'visible' }}
              borderRadius={0}
              width={rpx2px(750)}
              height={rpx2px(220)}
             >
             
             </LImage> */}
            <CloseBtn style={{
                position: 'absolute',
                right: '25rpx',
                bottom: '30rpx'
            }} onClose={props.onCloseModal}/>
          </View>}>
        {renderContent()}
      </BottomSliderModal>
    </TopView>;
};
export default memo(CouponUsageRecord);
